// extracted by mini-css-extract-plugin
module.exports = {"contacts_img_block":"bannerBlock_contacts_img_block__2Gtwq"};